export default __webpack_public_path__ + "static/media/orisa-barrier.4a2ea800.mp3";